import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

// Link interno "Saiba mais" para reforço de SEO (link building interno).
// Renderizado apenas na home (via prop showLearnMore) para não gerar auto-link
// na própria página dedicada.
export const SaibaMais = ({ to, label }) => (
  <div className="container mx-auto px-4 relative z-10">
    <div className="text-center mt-10">
      <Link
        to={to}
        data-testid={`saiba-mais${to}`}
        className="inline-flex items-center gap-2 px-6 py-3 bg-slate-800/70 hover:bg-cyan-900/40 border border-slate-700 hover:border-cyan-500/50 text-white font-semibold rounded-full transition-all hover:scale-105 text-sm"
      >
        {label} <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  </div>
);

export default SaibaMais;
